<p-card class="xl-radius" [styleClass]="'mt-4 mb-4'">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-12">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Klant gegevens</h5>
            </div>
        </div>
    </ng-template>   
    <customer-details-general-data-component [customer]="customer"></customer-details-general-data-component>
    <ng-template #footer>
        <div class="row" [style]="{ 'border-top': '1px solid #e0e0e0' }">
            <div class="col-8 pt-4">
            </div>
            <div class="col-4 pt-4">
                <p-button class="float-right" [outlined]="true" label="Wijzigen" (click)="editCustomer()"></p-button>
            </div>
        </div>
    </ng-template>
</p-card>
<p-card class="xl-radius" [styleClass]="'mt-4 mb-4'">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-12">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Elektronische facturatie</h5>
            </div>
        </div>
    </ng-template>
    <div class="row">
        <div class="col-3" >
            <label>Facturatie per e-mail:</label>
        </div>
        <div class="col-9">
            <strong>{{ getEInvoiceStatus() }}</strong>
        </div>
    </div>
    <ng-template #footer>
        <div class="row" [style]="{ 'border-top': '1px solid #e0e0e0' }">
            <div class="col-8 pt-4">
            </div>
            <div class="col-4 pt-4">
                <p-button class="float-right" [outlined]="true" label="Wijzigen" (click)="editPaymentMethod()"></p-button>
            </div>
        </div>
    </ng-template>
</p-card>

<p-card class="xl-radius" [styleClass]="'mt-4 mb-4'">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-12">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Account</h5>
            </div>
        </div>
    </ng-template>
    <div class="row">
        <div class="col-3">
            <label>Gebruikersnaam:</label>
        </div>
        <div class="col-9">
            <strong>{{ customer?.loginName }}</strong>
        </div>
        <div class="col-3">
            <label>Wachtwoord:</label>
        </div>
        <div class="col-9">
            <strong style="user-select: none;">***************</strong>
        </div>
    </div>
    <ng-template #footer>
        <div class="row" [style]="{ 'border-top': '1px solid #e0e0e0' }">
            <div class="col-8 pt-4">
            </div>
            <div class="col-4 pt-4">
                <p-button class="float-right" [outlined]="true" label="Wachtwoord wijzigen" (click)="resetPassword()"></p-button>
            </div>
        </div>
    </ng-template>
</p-card>

<p-card class="xl-radius" [styleClass]="'mt-4 mb-4'">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-12">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Facturatie- en postadres</h5>
            </div>
        </div>
    </ng-template>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Voornaam:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoiceAddressFirstName }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Naam:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoiceAddressLastName }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Straat:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoicingAddressStreetName }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Nr.:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoicingAddressHouseNumber }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Busnr.:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoicingAddressBusNumber }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Postcode:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoicingAddressPostalCode }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Plaats:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoicingAddressLocation }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>Land:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ customer?.invoicingAddressCountry }}</strong>
        </div>
    </div>
    <ng-template #footer>
        <div class="row" [style]="{ 'border-top': '1px solid #e0e0e0' }">
            <div class="col-8 pt-4">
            </div>
            <div class="col-4 pt-4">
                <p-button class="float-right" [outlined]="true" label="Wijzigen" (click)="editInvoiceAddress()"></p-button>
            </div>
        </div>
    </ng-template>
</p-card>

<p-card class="xl-radius" [styleClass]="'mt-4 mb-4'">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-12">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Financiële gegevens</h5>
            </div>
        </div>
    </ng-template>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>IBAN-nr.:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ paymentDetails?.iban }}</strong>
        </div>
    </div>
    <div class="row">
        <div class="xl:col-3 lg:col-3 col-12">
            <label>BIC-code:</label>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
            <strong>{{ paymentDetails?.bic }}</strong>
        </div>
    </div>
    <ng-template #footer>
        <div class="row" [style]="{ 'border-top': '1px solid #e0e0e0' }">
            <div class="col-8 pt-4">
            </div>
            <div class="col-4 pt-4">
                <p-button class="float-right" [outlined]="true" label="Wijzigen" (click)="editPaymentDetails()"></p-button>
            </div>
        </div>
    </ng-template>
</p-card>